import { getCard, postDefaultCard } from 'lib/api';

type stateT = {
  sub?: subscriptionT,
  plans?: Array<planT>,
  card?: cardT,
  bankAccount?: bankAccountT,
  orgCoupon?: orgCouponT,
  vat?: vatT,
  updating: boolean,
  cardUpdating: boolean,
  bankAccountUpdating: boolean,
  vatUpdating: boolean,
  orgCouponLoading: false,
  cardError: string | null,
};

// ACTIONS
export type actionT =
  | {
      type: 'SUB_UPDATE_SUB',
      sub: subscriptionT,
    }
  | {
      type: 'SUB_UPDATE_PLANS',
      plans: Array<planT>,
    }
  | {
      type: 'SUB_UPDATE_CARD',
      card: cardT,
    }
  | {
      type: 'SET_ORG_COUPON',
      orgCoupon: orgCouponT,
    }
  | {
      type: 'SUB_UPDATE_BANK_ACCOUNT',
      bankAccount: bankAccountT,
    }
  | {
      type: 'SUB_UPDATE_VAT',
      vat: vatT,
    }
  | {
      type: 'SUB_UPDATING',
      updating: boolean,
    }
  | {
      type: 'SUB_CARD_UPDATING',
      updating: boolean,
    }
  | {
      type: 'SUB_ORG_COUPON_LOADING',
      loading: boolean,
    }
  | {
      type: 'SUB_BANK_ACCOUNT_UPDATING',
      updating: boolean,
    }
  | {
      type: 'SUB_VAT_UPDATING',
      updating: boolean,
    };

export function updateSub({ sub }: { sub: subscriptionT }): actionT {
  return {
    type: 'SUB_UPDATE_SUB',
    sub,
  };
}

export function updatePlans({ plans }: { plans: Array<planT> }): actionT {
  return {
    type: 'SUB_UPDATE_PLANS',
    plans,
  };
}

export function updating(updating: boolean): actionT {
  return {
    type: 'SUB_UPDATING',
    updating,
  };
}

export function cardUpdating(updating: boolean): actionT {
  return {
    type: 'SUB_CARD_UPDATING',
    updating,
  };
}

export function updateCard({ card }: { card: cardT }): actionT {
  return {
    type: 'SUB_UPDATE_CARD',
    card,
  };
}

export function cardUpdatingError(error: string): actionT {
  return {
    type: 'SUB_CARD_UPDATING_ERROR',
    cardError: error,
  };
}

// STORE
const initalSubState: stateT = {
  updating: false,
  cardUpdating: false,
  cardError: null,
  vatUpdating: false,
  bankAccountUpdating: false,
  orgCouponLoading: false,
};

export function subscription(state: stateT = initalSubState, action: actionT): state {
  switch (action.type) {
    case 'SUB_UPDATE_SUB':
      return {
        ...state,
        updating: false,
        sub: action.sub,
      };
    case 'SUB_UPDATE_PLANS':
      return {
        ...state,
        updating: false,
        plans: action.plans,
      };
    case 'SUB_UPDATE_CARD':
      return {
        ...state,
        cardUpdating: false,
        cardError: null,
        card: action.card,
      };
    case 'SUB_CARD_UPDATING_ERROR':
      return {
        ...state,
        cardUpdating: false,
        cardError: action.cardError,
      };
    case 'SET_ORG_COUPON':
      return {
        ...state,
        orgCouponLoading: false,
        orgCoupon: action.orgCoupon,
      };
    case 'SUB_UPDATE_BANK_ACCOUNT':
      return {
        ...state,
        bankAccountUpdating: false,
        bankAccount: action.bankAccount,
      };
    case 'SUB_UPDATE_VAT':
      return {
        ...state,
        vatUpdating: false,
        vat: action.vat,
      };
    case 'SUB_UPDATING':
      return {
        ...state,
        updating: action.updating,
      };
    case 'SUB_CARD_UPDATING':
      return {
        ...state,
        cardUpdating: action.updating,
      };
    case 'SUB_ORG_COUPON_LOADING':
      return {
        ...state,
        orgCouponLoading: action.loading,
      };
    case 'SUB_BANK_ACCOUNT_UPDATING':
      return {
        ...state,
        bankAccountUpdating: action.updating,
      };

    default:
      return state;
  }
}

// Thunks
export function loadCard({ organizationId }: { organizationId: string }) {
  return function (dispatch, getState, axios) {
    dispatch(cardUpdating(true));
    getCard(localStorage, axios, { organizationId }).then(({ card }) => {
      dispatch(updateCard({ card }));
    });
  };
}

export function setDefaultCard({ organizationId, setupIntent }: { organizationId: string, setupIntent: string }) {
  return function (dispatch, getState, axios) {
    dispatch(cardUpdating(true));
    postDefaultCard(localStorage, axios, {
      organizationId,
      setupIntent,
    })
      .then(({ card }) => {
        dispatch(updateCard({ card }));
      })
      .catch((err) => {
        dispatch(cardUpdatingError(err.response.data.error_message));
      });
  };
}

export function displayTrialHeader(state: stateT): boolean {
  return state.sub !== undefined && state.sub.status.indexOf('trialing') >= 0;
}
